import { RedirectWithQuery } from '@xylabs/sdk-react'
import { CoinSponsorStatus } from '@xyo-network/sdk-xyoworld-js'
import { useContext, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { AuthenticationContext, GeotokensSettingsContext } from '../../Contexts'
import GeotokenSettingsList from './List'

const InnerPage: React.FC = () => {
  const params = useParams()
  const { auth, authEntity } = useContext(AuthenticationContext)
  const { filter, updateFilter } = useContext(GeotokensSettingsContext)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const requestedFilter = params?.filter as CoinSponsorStatus

  if (!requestedFilter) {
    navigate(`${pathname}/${CoinSponsorStatus.All}`, { replace: true })
  }

  useEffect(() => {
    if (requestedFilter && filter !== requestedFilter) {
      updateFilter?.(requestedFilter)
    }
  }, [requestedFilter, filter, updateFilter])

  if (auth?.authenticated() === false || (authEntity && authEntity?.admin !== true)) {
    return <RedirectWithQuery to="/geotokens" />
  }

  return <GeotokenSettingsList />
}

export default InnerPage
